export default function ($) {
  $(document).on('click', '.js-less-quantity, .js-more-quantity', function () {
    const $btn = $(this);
    const $input = $btn.closest('.js-quantity-stepper').find('input.qty');
    const currentVal = parseFloat($input.val()) || 0;
    const min = parseFloat($input.attr('min')) || 0;
    const max = parseFloat($input.attr('max')) || Infinity;
    const step = parseFloat($input.attr('step')) || 1;

    let newVal;
    if ($btn.hasClass('js-less-quantity')) {
      newVal = Math.max(min, currentVal - step);
    } else {
      newVal = max > 0 && isFinite(max) ? Math.min(max, currentVal + step) : currentVal + step;
    }

    if (newVal !== currentVal) {
      $input.val(newVal).trigger('change');
    }
  });
}
